import { render, staticRenderFns } from "./KeywordEdit.vue?vue&type=template&id=45297920&scoped=true&"
import script from "./KeywordEdit.vue?vue&type=script&lang=js&"
export * from "./KeywordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45297920",
  null
  
)

export default component.exports